import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';
import { businessInfo } from '../shopData';

const Hero = () => {
  const navigate = useNavigate();

  const scrollToCategories = () => {
    const element = document.getElementById('categories');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const goToShop = () => {
    navigate('/shop');
  };

  return (
    <section id="hero" className="hero-section">
      <div className="hero-overlay-new"></div>
      <div className="hero-image" style={{
        backgroundImage: 'url(https://images.pexels.com/photos/19820885/pexels-photo-19820885.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940)'
      }}></div>
      
      <div className="hero-content">
        <div className="max-w-5xl mx-auto text-center px-4">
          <div className="hero-brand-wrapper">
            <div className="hero-brand-script">Shri Kothari</div>
            <div className="hero-brand-main">JEWELLERS</div>
          </div>
          
          <div className="hero-since">Since 1987</div>
          
          <h1 className="hero-headline">
            Premium Silver Collection
          </h1>
          
          <p className="hero-subtext">
            Indore's Premier Destination for Pure Silver Jewellery, Sacred Idols, Elegant Utensils & Personalised Silver Gifts
          </p>
          
          <div className="hero-buttons">
            <button onClick={goToShop} className="btn-primary-hero">
              Explore Collection
            </button>
            <a 
              href={`https://wa.me/${businessInfo.whatsappNumber}`}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-secondary-hero"
            >
              Contact Us
            </a>
          </div>
        </div>
        
        <button onClick={scrollToCategories} className="scroll-indicator">
          <ChevronDown size={32} className="animate-bounce" />
        </button>
      </div>
    </section>
  );
};

export default Hero;
